<template>
  <div class="recommended-container">
    <el-table :data="productList"
              size="mini"
              style="width: 100%"
              height="100%">
      <el-table-column prop="createOn"
                       label="创建时间"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.createOn | date }}
        </template>
      </el-table-column>
      <el-table-column prop="productName"
                       label="物料名称"> </el-table-column>
      <el-table-column label="品项">
        <template slot-scope="scope">
          <el-tag :type="scope.row.qualityName | qualityType"
                  size="mini">
            {{ scope.row.qualityName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="quantity"
                       label="数量"> </el-table-column>
      <el-table-column prop="price"
                       label="价格"> </el-table-column>
      <el-table-column prop="priceDate"
                       label="价格有效期"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.priceDate | date }}
        </template>
      </el-table-column>
      <el-table-column prop="remark"
                       label="备注"
                       width="200"> </el-table-column>
      <!-- <el-table-column prop="recommendDate"
                       label="推荐时间">
        <template slot-scope="scope">
          {{ scope.row.recommendDate | date }}
        </template>
      </el-table-column> -->
      <el-table-column label="状态"
                       width="80">
        <template slot-scope="props">
          <span v-if="props.row.invalid">已失效</span>
          <span v-else>已推荐</span>
        </template>
      </el-table-column>
      <el-table-column prop="invalidCause"
                       label="失效原因"
                       width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.invalid">{{ scope.row.invalidCause }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="产品图片">
        <template slot-scope="scope">
          <el-image style="width: 40px; height: 40px"
                    v-if="scope.row.uploadFiles.length > 0"
                    :src="scope.row.uploadFiles[0].sitePath"
                    :preview-src-list="previewFiles(scope.row.uploadFiles)">
            <div slot="error"
                 class="image-slot">
              <img src="@images/watermark.jpg"
                   style="width: 40px; height: 40px;"
                   alt="" />
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="120"
                       align="center"
                       fixed="right">
        <template slot-scope="scope">
          <el-button type="text"
                     v-if="!scope.row.invalid"
                     @click="handleInvalid(scope.row.id)">
            失效
          </el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="失效原因"
               :visible.sync="isShowInvalidDialog"
               width="500px"
               :before-close="handleDialogClose"
               class="invalid-dialog">
      <el-form ref="invalidFormRef"
               :model="invalidForm">
        <el-form-item>
          <el-radio-group v-model="invalidForm.invalidReason"
                          @change="handleChange">
            <el-radio label="缺货"
                      name="invalidReason"></el-radio>
            <el-radio label="货物质量问题"
                      name="invalidReason"></el-radio>
            <el-radio label="价格调整"
                      name="invalidReason"></el-radio>
            <el-radio label="信息录入错误"
                      name="invalidReason"></el-radio>
            <el-radio label="其他"
                      name="invalidReason"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-input v-model="invalidForm.otherInvalidReason"
                    type="textarea"
                    maxlength="30"
                    v-if="isShowArea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="handleConfirm"
                   size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    productList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isShowInvalidDialog: false,
      isShowArea: false,
      invalidId: '',
      invalidForm: {
        invalidReason: '',
        invalidType: 1,
        otherInvalidReason: ''
      }
    }
  },
  created () { },
  methods: {
    previewFiles (files) {
      let arr = []
      files.forEach(item => {
        arr.push(item.sitePath)
      })
      return arr
    },
    handleInvalid (id) {
      this.isShowInvalidDialog = true
      this.invalidId = id
    },
    handleChange (value) {
      if (value === '其他') {
        this.isShowArea = true
      } else {
        this.isShowArea = false
        this.otherInvalidReason = ''
      }
    },
    handleDialogClose (done) {
      this.isShowArea = false
      this.invalidForm = {
        invalidReason: '',
        invalidType: 1,
        otherInvalidReason: ''
      }
      done()
    },
    handleConfirm () {
      let invalidCause = ''
      if (this.invalidForm.otherInvalidReason === '') {
        invalidCause = this.invalidForm.invalidReason
      } else {
        invalidCause = '其他： ' + this.invalidForm.otherInvalidReason
      }
      const params = {
        invalidCause,
        id: this.invalidId
      }
      this.$http
        .put('/api/services/inquiryApp/productRecommend/Invalid', params)
        .then(res => {
          if (res.success) {
            this.$message.success('操作成功！')
            this.$emit('getRecommendList')
            this.isShowInvalidDialog = false
            this.isShowArea = false
            this.invalidForm = {
              invalidReason: '',
              otherInvalidReason: ''
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.recommended-container {
  height: 100%;
  overflow: auto;
}
.invalid-dialog {
  /deep/ .el-dialog__body {
    padding: 0 20px;
    .el-form-item {
      margin-bottom: 0;
    }
    .el-radio {
      display: block;
      padding: 10px 0;
    }
  }
}
</style>
